import auth from './auth';
import catchments from './catchments';
import common from './common';
import doctors from './doctors';
import hospitals from './hospitals';
import map from './map';
import pharmacies from './pharmacies';

export default {
  auth,
  catchments,
  common,
  doctors,
  hospitals,
  map,
  pharmacies,
};
